import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const EditGeneralSetting = createSlice({
  name: "EditGeneralSetting",
  initialState: {
    isLoading: false,
    api_completed: false,
    data: [],
  },
  reducers: {
    raise_api_call_edit_general_setting: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call: (state, action) => {
      state.data = action.payload;
      state.api_completed = true;
      state.isLoading = false;
    },
    failure_api_call: (state, action) => {
      state.api_completed = true;
      state.isLoading = false;
    },
    edit_general_setting_complete_api: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default EditGeneralSetting.reducer;
export const {
  raise_api_call_edit_general_setting,
  success_api_call,
  failure_api_call,
  edit_general_setting_complete_api,
} = EditGeneralSetting.actions;
